import React, { useEffect, useRef, useState, useMemo } from 'react';
//Bhupenleyers 

import "@arcgis/core/assets/esri/themes/light/main.css";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
//Bhupenlayers

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import Graphic from "@arcgis/core/Graphic";

import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";


import "@arcgis/core/assets/esri/themes/light/main.css"; // ArcGIS theme

import { FaHome, FaTint, FaWater, FaReceipt, FaUsers, FaBus, FaChartArea } from 'react-icons/fa';
import { Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setIsBufferWidth, setIsSidebar } from '../store/slice/currentStageSlice';


const tabItems = [
    { key: 'total', label: 'All Properties', icon: <FaHome className="mr-2" size={20} /> },
    { key: 'Paid', label: 'Paid', icon: <FaTint className="mr-2" size={20} /> },
    { key: 'Unpaid', label: 'UnPaid', icon: <FaTint className="mr-2" size={20} /> },
    { key: 'Not Registered', label: 'Not Registered on ENP', icon: <FaTint className="mr-2" size={20} /> },
    { key: 'Negative Arrear', label: 'Properties with Negativ Aarrier', icon: <FaTint className="mr-2" size={20} /> },

];

const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";


//Bhupenleyers 
const MAPTaxInsights = ({
    selectedDistrict,
    selectedUlb,
    selectedWard,
    districtCode,
    ulbCode,
    wardCode,
    activeTabinfo,activeTabRef, dist_cd, ulb_cd, wardno, selectedTitle,
    selectedLayer, onViewReady, isWidth, isScreenSize, isByDefaultActive, locationAi,groups
}) => {

     const mapRef = useRef(null);     // DOM reference
      const viewRef = useRef(null);    // ArcGIS MapView reference
    
    const mapDiv = useRef(null);
    const layerRef = useRef(null);

    const [view, setView] = useState(null);

    console.log("activeTabinfoactiveTabinfo",activeTabinfo)
    // Code for Bhupen 22AUG
    const [activeTab, setActiveTab] = useState(activeTabinfo || 'total');
       const [activeTab1, setActiveTab1] = useState(activeTabRef || '0');

    const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
    const { isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
    const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
    const legendWidgetRef = useRef(null);
    const dispatch = useDispatch();
    const buildFilter = (dist_cd, ulb_cd, wardno) => {
        const conditions = [];
        if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
        if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
        if (wardno) conditions.push(`wardno = '${wardno}'`);

        return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
    };




  useEffect(() => {
    // Create the base map and view only once
    if (!viewRef.current) {
      const map = new Map({
        basemap: "topo-vector",
      });

      const view = new MapView({
        container: mapRef.current,
        map: map,
        center: [78.6569, 23.2599], // Center on MP
        zoom: 6,
         ui: { components: ["attribution"] }
      });

      viewRef.current = view;
      
        const layer = new MapImageLayer({ url: mainLayerUrl, sublayers: [] });
        map.add(layer);
        layerRef.current = layer;
        setView(view);



        
// code for Legend
  view.ui.add(new Search({ view: view }), "top-left");
        view.ui.add(new Home({ view: view }), "top-left");
        view.ui.add(new Zoom({ view: view }), "top-left");
        view.ui.add(new Expand({ view: view, content: new BasemapGallery({ view: view }) }), "top-right");
        view.ui.add(new Locate({ view: view, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-right");
        view.ui.add(new ScaleBar({ view: view }), "bottom-right");

        view.when(() => {
            const printWidget = new Print({
                view: view,
                printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
            });

            const expandPrint = new Expand({
                view: view,
                content: printWidget
            });

            view.ui.add(expandPrint, "top-right");

            // ✅ Add and attach legend
            const legendWidget = new Legend({
                view: view,
                style: "classic"
            });

            const legendExpand = new Expand({
                view: view,
                content: legendWidget,
                expanded: false
            });

            view.ui.add(legendExpand, "top-right");
            legendWidgetRef.current = legendWidget;
        });

        //  legend  layerList

        const layerList = new LayerList({
            view: view
        });

        const expand = new Expand({
            view: view,
            content: layerList,
            expanded: false
        });

        view.ui.add(expand, "top-right");


// code for leged

    }
  }, []);


     //  Bhupenlayers
    useEffect(() => {
        if (!viewRef.current) return;

        const map = viewRef.current.map;

        // Remove all layers before adding new ones
        map.removeAll();

        const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
        // Add each group as a separate MapImageLayer
        groups.forEach(group => {
            const visibleSublayers = group.sublayers.filter(s => s.visible);

            if (visibleSublayers.length > 0) {

                //alert(`group.url on MAP: ${group.url}`);
                //alert(`group.title on MAP: ${group.title}`);

                // handleTabClick(activeTabinfo);
                const layer = new MapImageLayer({
                    url: group.url,
                    title: group.title,
                    sublayers: visibleSublayers.map(s => ({
                        id: s.id,
                        visible: true,
                        definitionExpression: filterExpr
                    })),
                });
                handleTabClick(activeTabinfo);

                map.add(layer);

// code for groups 
                if (groups) {
                    groups.forEach(group => {
                        const visibleSublayers = group.sublayers.filter(s => s.visible);

                        if (visibleSublayers.length > 0) {

                            visibleSublayers.forEach(s => {


                                // // Water  for RoadS 
                                if (s.title === "Lake/Pond/Reservoir") {

                                    console.log("Bhupen test ");
                                    console.log(s.title);
                                    //  alert(s.title);
                                    const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer";
                                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                                    const WBLayersUrl = new MapImageLayer({
                                        url: BaseMapURL,
                                        sublayers: [
                                            { id: 75, title: "Lake/Pond/Reservoir", visible: true, definitionExpression: filterExpr },

                                        ]
                                    });
                                    view.map.add(WBLayersUrl);
                                    layerRef.current = WBLayersUrl;

                                }

                                /*/  MapServer*/
                                //   railways  for RoadS 
                                if (s.title === "Roads") {

                                    const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer";
                                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                                    const Trasportlayer = new MapImageLayer({
                                        url: BaseMapURL,
                                        sublayers: [
                                            { id: 45, title: "Roads", visible: true, definitionExpression: filterExpr },
                                        ]
                                    });
                                    view.map.add(Trasportlayer);
                                    layerRef.current = Trasportlayer;
                                }
                                //   railways  for RoadS 
                                if (s.title === "Railway") {

                                    const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer";
                                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                                    const Trasportlayer = new MapImageLayer({
                                        url: BaseMapURL,
                                        sublayers: [
                                            { id: 56, title: "Railway", visible: true, definitionExpression: filterExpr },

                                        ]
                                    });
                                    view.map.add(Trasportlayer);
                                    layerRef.current = Trasportlayer;
                                }

                                // "Important Landmarks", 

                                if (s.title === "Important Landmarks") {

                                    const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer";
                                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                                    const Trasportlayer = new MapImageLayer({
                                        url: BaseMapURL,
                                        sublayers: [
                                            { id: 79, title: "Important Landmarks", visible: true, definitionExpression: filterExpr },

                                        ]
                                    });
                                    view.map.add(Trasportlayer);
                                    layerRef.current = Trasportlayer;
                                }
                               // "Building Footprint"   },

                                if (s.title === "Building Footprint") {

                                    const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/MapServer";
                                    const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
                                    const Trasportlayer = new MapImageLayer({
                                        url: BaseMapURL,
                                        sublayers: [
                                            { id: 15, title: "Building Footprint", visible: true, definitionExpression: filterExpr },

                                        ]
                                    });
                                    view.map.add(Trasportlayer);
                                    layerRef.current = Trasportlayer;
                                }



                            });  // end if groups tag

                        }
                    });


                }

// code for groups 

            }
        });

    }, [groups]);

    // code  Layers





    useEffect(() => {
        if (!view) return;
       // view.graphics.removeAll();


        handleTabClick(activeTabinfo);

        if (selectedWard && wardCode && ulbCode) {
            zoomToWard(wardCode, ulbCode);
        } else if (selectedUlb && ulbCode) {
            zoomToUlb(selectedUlb);
        } else if (selectedDistrict && districtCode) {
            zoomToDistrict(selectedDistrict);
        }
    }, [selectedDistrict, selectedUlb, selectedWard, districtCode, ulbCode, wardCode, view, activeTabinfo]);

    const zoomToDistrict = async (districtName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/3')}` });
        const query = new Query({ where: `districtname = '${districtName}'`, returnGeometry: true });
        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        outline: { color: [0, 255, 0], width: 2.0 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to district:", error);
        }
    };

    const zoomToUlb = async (ulbName) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/5')}` });
        const query = new Query({ where: `name = '${ulbName}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                const graphic = new Graphic({
                    geometry: features[0].geometry,
                    symbol: {
                        type: "simple-fill",
                        color: [0, 0, 255, 0.0],
                        //outline: { color: [0, 0, 255], width: 2 }
                    }
                });
                view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.5));
            }
        } catch (error) {
            console.error("Error zooming to ULB:", error);
        }
    };
  const zoomToWard = async (wardCode, ulbCode) => {
        const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/7')}` });
        const query = new Query({ where: `wardno = '${wardCode}' AND ulb_cd = '${ulbCode}'`, returnGeometry: true });

        try {
            const { features } = await layer.queryFeatures(query);
            if (features.length) {
                // const graphic = new Graphic({
                //     geometry: features[0].geometry,
                //     symbol: {
                //         type: "simple-fill",
                //         color: [0, 0, 255, 0.0],
                //         outline: { color: [0, 255, 0], width: 1.0 }
                //     }
                // });
                // view.graphics.add(graphic);
                view.goTo(features[0].geometry.extent.expand(1.0));
            }
        } catch (error) {
            console.error("Error zooming to ward:", error);
        }
    };

    const LoadZoom = () => {
        //  alert(`Card Title on MAP: ${selectedTitle}`);


 if(activeTabRef==="1")
             {
                activeTabRef="0"
              // zoomToDistrictOUT(selectedDistrict);
view.graphics.removeAll(); // Clear any highlights

    // Go to the initial extent or center
    view.goTo({
        center: [77.4126, 23.2599],
            zoom: 6,
            ui: { components: ["attribution"] }
    });

                 }
             else

                {
        if (selectedWard && wardCode && ulbCode) {
            zoomToWard(selectedWard, ulbCode);
        } else if (selectedUlb && ulbCode) {
            zoomToUlb(selectedUlb);
        } else if (selectedDistrict && districtCode) {
            zoomToDistrict(selectedDistrict);
        }
    }



    };
    const handleTabClick = (key) => {
        //setActiveTab(key);

 

        if (view && layerRef.current) {
            //view.graphics.removeAll();
            LoadZoom();

            view.map.removeAll();

// code for image layer  GUNA
               const IMGLAyerGUNA = new MapImageLayer({
                 url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/guna2017/MapServer",
                 
                sublayers: [
                    { id: 0,title:"Guna-Satelite-2017" ,visible:false},
                  
                ]
            });
            view.map.add(IMGLAyerGUNA);
            layerRef.current = IMGLAyerGUNA;
// code for image layer GUNA


// code for image layer  Makoriya
               const IMGLAyerMAKRONIYA = new MapImageLayer({
                 url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/makroniya2017/MapServer",
                
                sublayers: [
                    { id: 0,title:"Makroniya-Satelite-2017",visible:false },                  
                ]
            });
            view.map.add(IMGLAyerMAKRONIYA);
            layerRef.current = IMGLAyerMAKRONIYA;
// code for image layer Makoriya



            // code for Proerties
            if (key === "property" && view) {
                // code for Proerties

            }
            const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

            const adminLayer = new MapImageLayer({
                url: mainLayerUrl,
                sublayers: [
                    { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
                    { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
                    { id: 5, title: "ULB", visible: true, definitionExpression: filterExpr },
                    { id: 7, title: "Ward", visible: true, definitionExpression: filterExpr },
                ]
            });

            view.map.add(adminLayer);
            layerRef.current = adminLayer;


            if (key === "total" && view) {


                const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

                const waterLayer = new MapImageLayer({
                    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer",
                    sublayers: [
                        {
                            id: 1, title: "Property Taxinfo ", visible: true, definitionExpression: filterExpr, minScale: 250000,

                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property ID: {relation_id}",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ownername", label: "Owner Name" },
                                            { fieldName: "mobileno", label: "Mobile No" },
                                            { fieldName: "address", label: "Address" },
                                            { fieldName: "paymentstatus", label: "Payment Status" },
                                            { fieldName: 'totaltaxdue', label: "Total Tax Due:" },
                                        ]
                                    },
                                    {
                                        type: "media",
                                        mediaInfos: [
                                            {
                                                title: "<b>Property Photo</b>",
                                                type: "image",
                                                caption: "Linked to Relation ID",
                                                value: {
                                                    sourceURL:
                                                        "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                }
                                            }
                                        ]
                                    },{
                        type: "text",
                        text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                    }
                                ]
                            }//poptype close

                        },
                    ]
                });
                const layer = new MapImageLayer({
                    url: mainLayerUrl,
                    sublayers: [adminLayer],
                });

                view.map.add(layer);
                layerRef.current = layer;
                // setView(mapView);
                view.map.add(waterLayer);

                view.map.add(waterLayer);
                layerRef.current = waterLayer;

                // ✅ Update legend dynamically
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: waterLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }// if end 


            if (key === "Paid" && view) {



                // Build base filter expression
                let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                // Add condition for remarks = 'Surveyed'
                filterExpr += " AND paymentstatus = 'Paid'";


                // Create waterLayer with the full filter expression
                const waterLayer = new MapImageLayer({
                    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer",
                    sublayers: [
                        {
                            id: 1, title: "Property Taxinfo ", visible: true, definitionExpression: filterExpr, minScale: 250000,
                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property ID: {relation_id}",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ownername", label: "Owner Name" },
                                            { fieldName: "mobileno", label: "Mobile No" },
                                            { fieldName: "address", label: "Address" },
                                            { fieldName: "paymentstatus", label: "Payment Status" },
                                            { fieldName: 'totaltaxdue', label: "Total Tax Due:" },
                                        ]
                                    },
                                    {
                                        type: "media",
                                        mediaInfos: [
                                            {
                                                title: "<b>Property Photo</b>",
                                                type: "image",
                                                caption: "Linked to Relation ID",
                                                value: {
                                                    sourceURL:
                                                        "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                }
                                            }
                                        ]
                                    },
                                    {
                        type: "text",
                        text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                    }
                                ]
                            }//poptype close



                        },
                    ]
                });

                // Adding adminLayer and waterLayer to the map
                view.map.add(adminLayer);
                view.map.add(waterLayer);

                // Store references (if needed)
                layerRef.current = { adminLayer, waterLayer };

                // Update legend dynamically for waterLayer
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: waterLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }



            if (key === "Unpaid" && view) {



                // Build base filter expression
                let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                // Add condition for remarks = 'Surveyed'
                filterExpr += " AND paymentstatus = 'Unpaid'";


                // Create waterLayer with the full filter expression
                const waterLayer = new MapImageLayer({
                    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer",
                    sublayers: [
                        {
                            id: 1, title: "Property Taxinfo ", visible: true, definitionExpression: filterExpr, minScale: 250000,
                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property ID: {relation_id}",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ownername", label: "Owner Name" },
                                            { fieldName: "mobileno", label: "Mobile No" },
                                            { fieldName: "address", label: "Address" },
                                            { fieldName: "paymentstatus", label: "Payment Status" },
                                            { fieldName: "totaltaxdue", label: "Total Tax Due " },
                                        ]
                                    },
                                    {
                                        type: "media",
                                        mediaInfos: [
                                            {
                                                title: "<b>Property Photo</b>",
                                                type: "image",
                                                caption: "Linked to Relation ID",
                                                value: {
                                                    sourceURL:
                                                        "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                }
                                            }
                                        ]
                                    },
                                    {
                        type: "text",
                        text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                    }
                                ]
                            }//poptype close





                        },
                    ]
                });

                // Adding adminLayer and waterLayer to the map
                view.map.add(adminLayer);
                view.map.add(waterLayer);

                // Store references (if needed)
                layerRef.current = { adminLayer, waterLayer };

                // Update legend dynamically for waterLayer
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: waterLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }

            if (key === "Not Registered" && view) {



                // Build base filter expression
                let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                // Add condition for remarks = 'Surveyed'
                filterExpr += " AND paymentstatus = 'Not Registered'";


                // Create waterLayer with the full filter expression
                const waterLayer = new MapImageLayer({
                    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer",
                    sublayers: [
                        {
                            id: 1, title: "Property Taxinfo ", visible: true, definitionExpression: filterExpr, minScale: 250000,

                            popupEnabled: true,
                            popupTemplate: {
                                title: "Property ID: {relation_id}",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ownername", label: "Owner Name" },
                                            { fieldName: "mobileno", label: "Mobile No" },
                                            { fieldName: "address", label: "Address" },
                                            { fieldName: "paymentstatus", label: "Payment Status" },
                                            { fieldName: "totaltaxdue", label: "Total Tax Due " },
                                        ]
                                    },
                                    {
                                        type: "media",
                                        mediaInfos: [
                                            {
                                                title: "<b>Property Photo</b>",
                                                type: "image",
                                                caption: "Linked to Relation ID",
                                                value: {
                                                    sourceURL:
                                                        "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                }
                                            }
                                        ]
                                    },
                                    {
                        type: "text",
                        text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                    }
                                ]
                            }//poptype close








                        },
                    ]
                });

                // Adding adminLayer and waterLayer to the map
                view.map.add(adminLayer);
                view.map.add(waterLayer);

                // Store references (if needed)
                layerRef.current = { adminLayer, waterLayer };

                // Update legend dynamically for waterLayer
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: waterLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }
            //arrears 

            if (key === "Negative Arrear" && view) {



                // Build base filter expression
                let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);  // e.g. "dist_cd = 10 AND ulb_cd = 5 AND ward_no = 2"

                // Add condition for remarks = 'Surveyed'
                filterExpr += " AND arrears <0";


                // Create waterLayer with the full filter expression
                const waterLayer = new MapImageLayer({
                    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer",
                    sublayers: [
                        {
                            id: 1, title: "Property Taxinfo ", visible: true, definitionExpression: filterExpr, minScale: 250000,
                            popupTemplate: {
                                title: "Property ID: {relation_id}",
                                content: [
                                    {
                                        type: "fields",
                                        fieldInfos: [
                                            { fieldName: "e_nagarpalikaid", label: "E-Nagarpalika ID" },
                                            { fieldName: "relation_id", label: "Relation ID" },
                                            { fieldName: "ownername", label: "Owner Name" },
                                            { fieldName: "mobileno", label: "Mobile No" },
                                            { fieldName: "address", label: "Address" },
                                            { fieldName: "paymentstatus", label: "Payment Status" },
                                            { fieldName: "totaltaxdue", label: "Total Tax Due:  ₹" },

                                        ]
                                    },
                                    {
                                        type: "media",
                                        mediaInfos: [
                                            {
                                                title: "<b>Property Photo</b>",
                                                type: "image",
                                                caption: "Linked to Relation ID",
                                                value: {
                                                    sourceURL:
                                                        "https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id={relation_id}"
                                                }
                                            }
                                        ]
                                    },
                                    {
                        type: "text",
                        text: `<b></b><br>
              <img  src="" style="width:200px; height: 20px; border: 1px solid #ccc; margin-top: 5px;" 
               /><br>   <br> <br> <br> `
                                    }
                                ]
                            }//poptype close


                        },
                    ]
                });

                // Adding adminLayer and waterLayer to the map
                view.map.add(adminLayer);
                view.map.add(waterLayer);

                // Store references (if needed)
                layerRef.current = { adminLayer, waterLayer };

                // Update legend dynamically for waterLayer
                if (legendWidgetRef.current) {
                    legendWidgetRef.current.layerInfos = [{
                        layer: waterLayer,
                        title: `${key.charAt(0).toUpperCase() + key.slice(1)} Layers`
                    }];
                }
            }



        }
    };


    // code for zoom and UI Part 

    useEffect(() => {
        const handleResize = () => {
            setIsScreenSize1(window.innerWidth <= 991)
        };
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])


    const calculatedHeight = useMemo(() => {
        const hasFeatureTableData = setFeatureTable?.length > 0;
        if (isWidth && isByDefaultActive) {
            return "calc(100vh - 78px)"; // Adjust height as needed
        }


        if (isWidth) {
            return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
        }
        if (isWidth) {
            return "calc(100vh - 78px)"
        }
        if (!isWidth && hasFeatureTableData) {
            return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
        }
        if (!isWidth && hasFeatureTableData && isByDefaultActive) {
            return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
        }
        // if (isBufferWidth && isToolHeight) {
        //     return "calc(100vh - 110px)"
        // }
        if (isToolHeight) {
            return "calc(100vh - 330px)"
        }

        return "calc(100vh - 425px)";
    }, [isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight]);

    const handleToggleBufferWidth = () => {
        dispatch(setIsBufferWidth(!isBufferWidth));
    };
    const handleToggleBufferLeft = () => {
        dispatch(setIsSidebar(!isSideBar));
    };
 // code for zoom and UI Part 
    return (
        <div className='position-relative'>
            

            {currentStageValue === 0 ? "" :
                <div className={isWidth ? "d-none" : 'manage-buffer'} type="button" onClick={handleToggleBufferWidth}>
                    <div className={isBufferWidth ? 'not-rotate' : 'is-rotate'}>
                        <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                    </div>
                </div>
            }
            {currentStageValue === 0 ? "" :
                <div className={isWidth ? "d-none" : 'manage-buffer-left'} type="button" onClick={handleToggleBufferLeft}
                >
                    <div className={isBufferWidth ? 'is-rotate' : 'not-rotate'}>
                        <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
                    </div>
                </div>
            }

            <div
                ref={mapRef}
                style={{
                    width: "100%",
                    height: calculatedHeight,
                    // height: "450px",
                    // border: "4px solid #f39945ff",
                    borderRadius: "4px"
                }}
            />

            <style>
                {`
          html, body, #viewDiv {
            padding: 0;
            margin: 0;
            height: 100%;
            width: 100%;
          }

          .esri-popup--dock .esri-popup__main-container {
            max-height: 45vh !important;
          }

          .esri-popup__content,
          .esri-popup__content-inner,
          .esri-feature__content-node {
            max-height: 40vh !important;
            overflow-y: auto !important;
          }
        `}
            </style>
        </div>


    );
};

export default MAPTaxInsights;
